import React, { Component } from "react";
import { connect } from "react-redux";
import StaticModal from "../shared/StaticModal";
import {
  controlContactInfos,
  selectMemberInfo,
} from "../../../state/ducks/member/index";
import $ from "jquery";
import Inputmask from "inputmask";
function mailkontrol() {
  var result=false;
  var deger = document.getElementById('ePosta').value;
  // var regex = /^[a-zA-Z0-9+\.]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;
  var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var durum = regex.test(deger);

  if (deger == "") {
      document.getElementById('ePosta').parentElement.classList.add("t-error"); // kutunun içini kırmızı yapıyorum.
      document.getElementById("ePosta").nextElementSibling.innerHTML = "<i class='t-icon-error text-danger'></i>";
      $(".t-icinputHatamesajArea").html("E-mail alanı boş bırakılamaz");
  } else if (deger !== "" && durum == true) {
      // email dolu regex e uygyn ise
      document.getElementById('tel').parentElement.classList.remove("t-error"); 
      document.getElementById("tel").nextElementSibling.innerHTML = "<i class='t-icon-check_circle_outline text-success'></i>";
      $(".t-icinputHatamesajArea").html("");
      result=true;
  } else {
    document.getElementById('ePosta').parentElement.classList.add("t-error"); // kutunun içini kırmızı yapıyorum.
    document.getElementById("ePosta").nextElementSibling.innerHTML = "<i class='t-icon-error text-danger'></i>";
      $(".t-icinputHatamesajArea").html("Lütfen Geçerli Bir E-mail giriniz");
  }
  return result;
}
function telkontrol(gsm) {
  var result=false;
  var deger = document.getElementById('tel').value;

  var durum = /^\(5[0-9]{2}\)\s[\d]{3}-[\d]{2}-[\d]{2}$/.test(gsm)

  if (deger == "") {
      document.getElementById('tel').parentElement.classList.add("t-error"); // kutunun içini kırmızı yapıyorum.
      document.getElementById("tel").nextElementSibling.innerHTML = "<i class='t-icon-error text-danger'></i>";
      $(".t-icinputHatamesajArea").html("Telefon alanı boş bırakılamaz");
  } else if (deger !== "" && durum == true) {
      // tel dolu regex e uygyn ise
    
      document.getElementById('tel').parentElement.classList.remove("t-error"); 
      document.getElementById("tel").nextElementSibling.innerHTML = "<i class='t-icon-check_circle_outline text-success'></i>";
      $(".t-icinputHatamesajArea").html("");
      result=true;
  } else {
    document.getElementById('tel').parentElement.classList.add("t-error"); // kutunun içini kırmızı yapıyorum.
    document.getElementById("tel").nextElementSibling.innerHTML = "<i class='t-icon-error text-danger'></i>";
      $(".t-icinputHatamesajArea").html("Lütfen Geçerli Telefon giriniz");
  }
  return result;
}

class ControlContactInfo extends Component {
  state = {
    bilgi: "",
    iletisimTur: this.props.match?.params?.id,
  };

  componentDidUpdate() {
    this.maskAndRegexInput();
    if (this.props.member?.controlContact) {
      this.props.history.push(
        "/Home/UpdateContactInfo/" + this.props.match?.params?.id
      );
    }
  }
  maskAndRegexInput() {
    var tel = document.getElementById("tel");

    if (tel != null) {
      Inputmask("(999) 999-99-99").mask(tel);  
    }

  }
  submit = (event) => {
    event.preventDefault();
    var button=event.currentTarget.id;
    if(button=="submitMail"){

      if (mailkontrol()) {
        this.props.controlContactInfo(this.state.bilgi, this.state.iletisimTur);
      }
    }
    else {
      if (telkontrol(this.state.bilgi)) {
        this.props.controlContactInfo(this.state.bilgi.replace(/\D/g, ''), this.state.iletisimTur);
      }
    }
    
  };

  render() {
    const { match } = this.props;
    return (
      <>
        
          <div className="container-fluid" hidden={match?.params?.id !== "Eposta"}>
          <div className="row" style={{ padding: "3%" }}>
            <div className="col-12">
              {/* KUTU 1 */}
              <div className="row no-gutters t-kutu t-yesilCizgi">
                <div
                  className="col bosluk backtop"
                  style={{
                    backgroundImage:
                    'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                  }}
                >
                  {/* içerikler */}
                  {/* Başlık */}
                  <div className="row no-gutters pb-4">
                    <div clss="col-auto">
                      <i className="t-icon-user1 icon" />
                    </div>
                    <div className="col d-flex flex-column justify-content-center">
                      <div className="baslik">Profilim</div>
                      <span className="altBaslik">
                        Üyelik Bilgilerim /{" "}
                        <span style={{ color: "#1D71B8" }}>Mail Adresimi Değiştir</span>
                      </span>
                    </div>
                  </div>
                  {/* Ad Soyad */}
                  <div className="row no-gutters my-4">
                    <div className="col-12 pb-1">
                      <span className="t-icInputTitle pl-3">Yeni Mail Adresiniz</span>
                    </div>
                    <div className="col-12">
                      <div className="t-icInput">
                        <div>
                          <i className="t-icon-mail1" />
                        </div>
                        <input
                          type="text"
                          placeholder="Yeni Mail Adresinizi Giriniz"
                          id="ePosta"
                          name="ePosta"
                          className="email"
                          value={this.state.bilgi}
                          autoComplete="false"
                          onChange={(e) => {
                            this.setState({ bilgi: e.target.value });
                          }}
                        />
                        <div></div>
                      </div>
                    </div>
                    {/* Hata mesajının geleceği alan*/}
                    <div className="col-12 t-icinputHatamesajArea pl-3 pt-1" />
                  </div>
                  {/* Değiştir*/}
                  <div className="row no-gutters p-2 justify-content-center mb-4">
                    <div className="col-auto">
                      <button
                        id="submitMail"
                        name="submitMail"
                        className="t-icButtonYesil"
                        onClick={this.submit}
                      >
                        <span />
                        <span className="pb-1">Değiştir</span>
                        <i
                          className="t-icon-arrow-right2"
                          style={{ fontSize: "14pt" }}
                        />
                      </button>
                    </div>
                  </div>
                  {/* STEP LER */}
                  <div className="row no-gutters pt-4 justify-content-center align-items-start">
                    {/* cizgi*/}
                    <div className="col-1 t-cizgiBackgroundKenar" />
                    {/* 1*/}
                    <div className="col-auto t-icStepAktif">
                      <div className="ortala">
                        <div className="yuvarlak">1</div>
                      </div>
                      <span>Yeni Mail</span>
                    </div>
                    {/* cizgi*/}
                    <div className="col-auto t-cizgiBackgroundOrta" />
                    {/* 2*/}
                    <div className="col-auto t-icStepPasif">
                      <div className="ortala">
                        <div className="yuvarlak">2</div>
                      </div>
                      <span>Onay</span>
                    </div>
                    {/* cizgi*/}
                    <div className="col-1 t-cizgiBackgroundKenar" />
                  </div>
                  {/* içerikler BİTTİ */}
                </div>
                <div className="col-auto renk" />
              </div>
              {/* KUTU 1 BİTTİ */}
            </div>
          </div>
          {/* Duyurlar Baslık*/}
          {/* duyrular Bitti*/}
          <div className="row" style={{ height: 30 }} />
         
        
        </div>
       
          <div className="container-fluid" hidden={match?.params?.id !== "Gsm"}>
            {/* Yeşil Alan*/}
            <div className="row" style={{ padding: "3%" }}>
              <div className="col-12">
                {/* KUTU 1 */}
                <div className="row no-gutters t-kutu t-yesilCizgi">
                  <div
                    className="col bosluk backtop"
                    style={{
                      backgroundImage:
                      'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                    }}
                  >
                    {/* içerikler */}
                    {/* Başlık */}
                    <div className="row no-gutters pb-4">
                      <div clss="col-auto">
                        <i className="t-icon-user1 icon" />
                      </div>
                      <div className="col d-flex flex-column justify-content-center">
                        <div className="baslik">Profilim</div>
                        <span className="altBaslik">
                          Üyelik Bilgilerim /{" "}
                          <span style={{ color: "#1D71B8" }}>
                            Cep Telefonumu Değiştir
                          </span>
                        </span>
                      </div>
                    </div>
                    {/* Ad Soyad */}
                    <div className="row no-gutters my-4">
                      <div className="col-12 pb-1">
                        <span className="t-icInputTitle pl-3">
                          Yeni Cep Telefon Numaranız
                        </span>
                      </div>
                      <div className="col-12">
                        <div className="t-icInput">
                          <div>
                            <i className="t-icon-phone1" />
                          </div>
                          <input
                            id="tel"
                            name="tel"
                            className="telefonnumber" 
                            placeholder="GSM Numaranız"
                            value={this.state.bilgi}
                           
                            onChange={(e) => {
                              this.setState({ bilgi: e.target.value });
                            }}
                          />
                          <div></div>
                        </div>
                      </div>
                      {/* Hata mesajının geleceği alan*/}
                      <div className="col-12 t-icinputHatamesajArea pl-3 pt-1" />
                    </div>
                    {/* Değiştir*/}
                    <div className="row no-gutters p-2 justify-content-center mb-4">
                      <div className="col-auto">
                        <button
                          id="submitTel"
                          name="submitTel"
                          className="t-icButtonYesil"
                          onClick={this.submit}
                        >
                          <span />
                          <span className="pb-1">Değiştir</span>
                          <i
                            className="t-icon-arrow-right2"
                            style={{ fontSize: "14pt" }}
                          />
                        </button>
                      </div>
                    </div>
                    {/* STEP LER */}
                    <div className="row no-gutters pt-4 justify-content-center align-items-start">
                      {/* cizgi*/}
                      <div className="col-1 t-cizgiBackgroundKenar" />
                      {/* 1*/}
                      <div className="col-auto t-icStepAktif">
                        <div className="ortala">
                          <div className="yuvarlak">1</div>
                        </div>
                        <span>Yeni Tel</span>
                      </div>
                      {/* cizgi*/}
                      <div className="col-auto t-cizgiBackgroundOrta" />
                      {/* 2*/}
                      <div className="col-auto t-icStepPasif">
                        <div className="ortala">
                          <div className="yuvarlak">2</div>
                        </div>
                        <span>Onay</span>
                      </div>
                      {/* cizgi*/}
                      <div className="col-1 t-cizgiBackgroundKenar" />
                    </div>
                    {/* içerikler BİTTİ */}
                  </div>
                  <div className="col-auto renk" />
                </div>
                {/* KUTU 1 BİTTİ */}
              </div>
            </div>
            {/* Duyurlar Baslık*/}
            {/* duyrular Bitti*/}
        
            <div className="row" style={{ height: 30 }} />
          </div>

       
        
      </>


    );
  }
}

const mapStateToProps = (state) => {
  return {
    member: selectMemberInfo(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  controlContactInfo: (bilgi, iletisimTur) =>
    dispatch(controlContactInfos(bilgi, iletisimTur)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ControlContactInfo);
